module.exports = __webpack_public_path__ + "static/FUJI-45acebe5953b18144dd7a399079cd81b.png";